import React, { useEffect, useState } from "react";
import { Editor } from "primereact/editor";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";
import { Quill } from "react-quill";
import FreeText from "./FreeText";

const Size = Quill.import("attributors/style/size");
Size.whitelist = ["12px", "14px", "18px", "24px", "32px"];
Quill.register(Size, true);

const FreeTextDefaultConfig = {
  content: "",
};

interface FreeTextConfig {
  content: string;
}

interface FreeTextEditorProps {
  config: FreeTextConfig;
  onConfigChange: (config: FreeTextConfig) => void;
}

const FreeTextEditor = ({ config, onConfigChange }: FreeTextEditorProps) => {
  const conf = config && Object.keys(config).length > 0 ? config : FreeTextDefaultConfig;
  const [value, setValue] = useState<string>(conf.content ?? "");

  useEffect(() => {
    onConfigChange({ content: value });
  }, [value]);

  const renderHeader = () => (
    <span className="ql-formats">
      <Button className="ql-bold" aria-label="Bold" />
      <Button className="ql-italic" aria-label="Italic" />
      <Button className="ql-underline" aria-label="Underline" />
      <Button className="ql-link" aria-label="Link" />
      <Button className="ql-image" aria-label="Image" />
      <Button className="ql-clean" aria-label="Clean" />
      <Button className="ql-code" aria-label="Code" />
      <select className="ql-size" aria-label="Font Size" defaultValue="16px">
        {Size.whitelist.map((s: string) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
      <select className="ql-align" aria-label="Align">
        <option value="" />
        <option value="center" />
        <option value="right" />
        <option value="justify" />
      </select>
    </span>
  );

  return (
    <div>
      <Editor
        value={value}
        onTextChange={e => setValue(e.htmlValue ?? "")}
        headerTemplate={renderHeader()}
        style={{ height: "320px" }}
      />
      <h4 className="border-bottom-1 pb-2 mb-2">{T("word.preview")}</h4>
      <FreeText content={value} />
    </div>
  );
};

export default FreeTextEditor;
